// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"bb4dfe2b","25":"c958e874","56":"a009e6a1","76":"99e829ae","229":"2f9fcd78","274":"e124765c","381":"2994c16e","677":"c958e874","736":"2f9fcd78","810":"bb4dfe2b"}[chunkId] + ".chunk.css";
};